export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  date: string;
}

export const featuredArticles: Article[] = [
  {
    slug: 'complete-kakobuy-spreadsheet-guide',
    title: 'The Complete Kakobuy Spreadsheet Guide: How to Find the Best Products in 2026',
    excerpt: 'Learn everything you need to know about using Kakobuy spreadsheets to discover trending products, compare prices, and make smarter shopping decisions. Our comprehensive guide covers spreadsheet navigation, category filtering, and expert tips.',
    category: 'Guides',
    readTime: '12 min read',
    date: '2026-07-05',
  },
];

export const allArticles: Article[] = [
  ...featuredArticles,
];